import { defineStore } from "pinia";

export const useDynamicInputStore = defineStore("dynamic-input-store", {
  state: () => ({
    dynamicInputValues: {},
    dynamicInputErrors: {},
    dynamicInputSuccesses: {},
  }),
  getters: {},
  actions: {
    getDynamicInputValue(key) {
      return this.dynamicInputValues[key] ?? "";
    },
    setDynamicInputValue(key, value) {
      this.dynamicInputValues[key] = value;
    },
    clearDynamicInputValue(key) {
      this.dynamicInputValues[key] = "";
    },
    getDynamicInputError(key) {
      return this.dynamicInputErrors[key] ?? "";
    },
    setDynamicInputError(key, error) {
      this.dynamicInputErrors[key] = error;
    },
    clearDynamicInputError(key) {
      this.dynamicInputErrors[key] = "";
    },
    getDynamicInputSuccess(key) {
      return this.dynamicInputSuccesses[key] ?? "";
    },
    setDynamicInputSuccess(key, success) {
      this.dynamicInputSuccesses[key] = success;
    },
    clearDynamicInputSuccess(key) {
      this.dynamicInputSuccesses[key] = "";
    },
  },
});

export default useDynamicInputStore;
